import React, { memo } from "react";

import { classNames, transformDateToLocalDateString } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { OFFICE_INTRO_SAMPLE } from "../consts";
import { OfficeSceneProps } from "../types";

/** Korak "Bilješke": interne bilješke poslovnice, važna je istaknuta. */
const OfficeNoteScene: React.FC<OfficeSceneProps> = ({ name }) => {
  const today = transformDateToLocalDateString(new Date());
  const importantNote = OFFICE_INTRO_SAMPLE.notes.find((note) => note.important);

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Bilješke</div>
          <div className="text-sm font-bold text-slate-800 truncate">{name}</div>
          <div className="mt-3 space-y-2">
            {OFFICE_INTRO_SAMPLE.notes.map((note) => (
              <div
                key={note.content}
                className={classNames(
                  "rounded-md px-3 py-2 text-[0.7rem]",
                  note.important ? "bg-amber-50 border-l-2 border-amber-400" : "bg-slate-50"
                )}
              >
                <div className="font-medium text-slate-700 line-clamp-2">{note.content}</div>
                <div className="mt-1 text-[0.6rem] text-slate-400">{today}</div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="inline-flex px-2 py-0.5 rounded-full text-[0.6rem] font-semibold bg-amber-100 text-amber-700">
            Važno
          </div>
          <p className="mt-2 text-[0.7rem] font-semibold leading-relaxed text-slate-700 line-clamp-3">
            {importantNote?.content}
          </p>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Ništa se ne zaboravlja"
          subtitle="Bilješke ostaju uz poslovnicu"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6zM14 2v6h6M8 13h8M8 17h5" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(OfficeNoteScene);
